export const version = "abi/5.2.0";
